export default __webpack_public_path__ + "static/media/li.f40550bf.svg";